
import './css/Style.css';
import ReactDOM from 'react-dom/client';
import React, { useState, useEffect, useRef } from 'react';



function ShowPopUpConfirmationV2({ msg, closePopup, callback = null, ignore_confirmation = false, titulo = "Informativo", msg_do_ok = 'Ok' }) {
    const [state, setState] = useState(false)
    const [msgPreparada, setMsgPreparada] = useState('');

    function closeBtn() {
        document.querySelectorAll("html")[0].style.overflow = "auto";
        closePopup();
    }
    function pressOk() {
        closeBtn();
        if (callback != null)
            callback();
    }

    useEffect(() => {
        if (!state)
            setState(true);
        else {
            if (msgPreparada == '') {
                const this_pop_up = document.getElementById("IDX_9989_POP_UP_CONTAINER");
                if (this_pop_up !== null) {
                    document.querySelectorAll("html")[0].style.overflow = "hidden";
                    setMsgPreparada(msg.split('<br>').map(str => <p key={parseInt(Math.random() * 200)}>{str}</p>));
                    this_pop_up.addEventListener('click', e => {//pra quando clicar fora na parte preta do aviso, pra ele fechar tambem
                        if (e.target.id === 'IDX_CONTAINER_POP_UP_EXTERNAL') {
                            const pop_up_idx_btn_sim = document.getElementById("pop_up_idx_btn_sim");
                            pop_up_idx_btn_sim !== null ? closeBtn() : pressOk();
                        }
                    });
                }
            }
        }
    }, [state]);

    return (
        <>
            <article style={{ display: 'none' }} name="call->nativeAplicationOnBackPress" onClick={closeBtn}></article>
            <div id="IDX_9989_POP_UP_CONTAINER" >
                {
                    callback != null && !ignore_confirmation ?
                        (
                            <div className="pop_up_confirmacao" id="IDX_CONTAINER_POP_UP_EXTERNAL">
                                <div className="pop_up">
                                    <div className="container" id="INFO_JS_ID_GLOBAL_POP_UP">
                                        <div className="pop_up_header">
                                            <h2 id="IDX_JS_POP_UP_TITULO_H2">{titulo}</h2>
                                            <button onClick={closeBtn} id='js_pop_up_confirmacao_close_btn'>X</button>
                                        </div>
                                        <div className="pop_up_msg" id="IDX_9989_POP_UP_MSG">
                                            {msgPreparada}
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <div className="pop_up_msg_opc">
                                        <button style={{ backgroundColor: "red" }} onClick={closeBtn} id="pop_up_idx_btn_nao">Não</button>
                                        <button onClick={pressOk} id="pop_up_idx_btn_sim">Sim</button>
                                    </div>
                                </div>
                            </div>
                        ) :
                        (
                            <div className="pop_up_confirmacao" id="IDX_CONTAINER_POP_UP_EXTERNAL">
                                <div className="pop_up">
                                    <div className="container" id="INFO_JS_ID_GLOBAL_POP_UP">
                                        <div className="pop_up_header">
                                            <h2 id="IDX_JS_POP_UP_TITULO_H2">{titulo}</h2>
                                            <button onClick={pressOk} id='js_pop_up_confirmacao_close_btn'>X</button>
                                        </div>
                                        <div className="pop_up_msg" id="IDX_9989_POP_UP_MSG">
                                            {msgPreparada}
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <div className="pop_up_msg_opc">
                                        <button id="pop_up_idx_btn_ok" onClick={pressOk}>{msg_do_ok}</button>
                                    </div>
                                </div>
                            </div>
                        )
                }
            </div>
        </>
    )
}

function ShowPopUpOkOrNoV2({ msg, closePopup, callback = null, callback_no = null }) {
    const [state, setState] = useState(false)
    const [msgPreparada, setMsgPreparada] = useState('');

    function closeBtn() {
        document.querySelectorAll("html")[0].style.overflow = "auto";
        closePopup();
    }
    function pressOk() {
        closeBtn();
        if (callback != null)
            callback();
    }
    function pressNo() {
        closeBtn();
        if (callback_no != null)
            callback_no();
    }



    useEffect(() => {
        if (!state)
            setState(true);
        else {
            if (msgPreparada == '') {
                const this_pop_up = document.getElementById("IDX_99897_POP_UP_CONTAINER");
                if (this_pop_up !== null) {
                    document.querySelectorAll("html")[0].style.overflow = "hidden";
                    setMsgPreparada(msg.split('<br>').map(str => <p key={parseInt(Math.random() * 200)}>{str}</p>));
                    this_pop_up.addEventListener('click', e => {//pra quando clicar fora na parte preta do aviso, pra ele fechar tambem
                        if (e.target.id === 'IDX_CONTAINER_POP_UP_EXTERNAL') {
                            pressNo();
                        }
                    });
                }
            }
        }
    }, [state]);

    return (
        <>
            <article style={{ display: 'none' }} name="call->nativeAplicationOnBackPress" onClick={pressNo}></article>
            <div id="IDX_99897_POP_UP_CONTAINER">
                <div className="pop_up_confirmacao" id="IDX_CONTAINER_POP_UP_EXTERNAL">
                    <div className="pop_up">
                        <div className="container" id="INFO_JS_ID_GLOBAL_POP_UP">
                            <div className="pop_up_header">
                                <h2 id="IDX_JS_POP_UP_TITULO_H2">Informativo</h2>
                                <button onClick={pressNo} id='js_pop_up_confirmacao_close_btn'>X</button>
                            </div>
                            <div className="pop_up_msg">
                                {msgPreparada}
                            </div>
                        </div>
                        <div className="pop_up_msg_opc">
                            <button style={{ backgroundColor: "red" }} onClick={pressNo} id="pop_up_idx_btn_nao">Não</button>
                            <button onClick={pressOk} id="pop_up_idx_btn_sim">Sim</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

let GLOGAL_ID_CARROSSEL = 0;
function setIdPopUpCarrossel(id, max) {
    if (id >= max)
        GLOGAL_ID_CARROSSEL = max - 1;
    else if (id < 0)
        GLOGAL_ID_CARROSSEL = 0;
    else
        GLOGAL_ID_CARROSSEL = id;
}
function getIdPopUpCarrossel() {
    return GLOGAL_ID_CARROSSEL;
}
function changeDotsFromCarrossel(pagina_inicial) {
    const pop_up_touch_dot_selecionado = document.getElementById("pop_up_touch_dot_selecionado");
    if (pop_up_touch_dot_selecionado !== null) {
        pop_up_touch_dot_selecionado.removeAttribute('id');
        pop_up_touch_dot_selecionado.parentElement.children[pagina_inicial].setAttribute("id", 'pop_up_touch_dot_selecionado');
        //if (_60_FPS_LOOP !== null && _60_FPS_LOOP._60_on_change_page != null && _60_FPS_LOOP._60_pagina_anterior !== _60_FPS_LOOP._60_pagina_inicial)//se tem o onchange, e se a pagina são diferentes
        if (_60_FPS_LOOP !== null && _60_FPS_LOOP._60_on_change_page != null)//se tem o onchange, e se a pagina são diferentes
            _60_FPS_LOOP._60_on_change_page();
    }
}
function carrossel_goto_image(pagina_inicial) {//quando clica nos botoes, ele teleporta para a imagem
    setIdPopUpCarrossel(pagina_inicial);
    const pop_up_container_mobileCircle = document.getElementById("pop_up_container_mobileCircle");
    pop_up_container_mobileCircle.scrollLeft = pagina_inicial * (pop_up_container_mobileCircle.clientWidth + 6);
    changeDotsFromCarrossel(pagina_inicial);
}

const targetFrameRate = 60;
class Time {
    static semEscalaTime = 0;
    static velocidadeTime = 90;
    static deltaTime = 0;
    static maximoDeltaTime = 0.3333333;
}
class _60_FPS_LOOP {
    static _60_is_next;
    static _60_pop_up_container_mobileCircle;
    static _60_it;
    static _60_max;
    static _60_pagina_anterior;
    static _60_pagina_inicial;
    static _60_on_change_page;

    static #requestUpdate() {
        requestAnimationFrame(this.#update.bind(this));
    }
    static #update() {
        // depois de calcular o deltaTime, fazer o render


        const fatiar_fps = (1 / targetFrameRate) - 0.005;
        for (let acumulador = (performance.now() / 1000) - Time.semEscalaTime; acumulador >= fatiar_fps; acumulador -= fatiar_fps) {
            const semEscalaDeltaTime = (performance.now() / 1000) - Time.semEscalaTime;
            Time.semEscalaTime += semEscalaDeltaTime;
            Time.deltaTime = Math.min(Math.max(semEscalaDeltaTime, 0), Time.maximoDeltaTime) * Time.velocidadeTime;
        }
        if (!((this._60_is_next && this._60_it >= this._60_max) || (!this._60_is_next && this._60_it <= this._60_max))) {
            const next_frame = (targetFrameRate / 2) * Time.deltaTime;
            this._60_pop_up_container_mobileCircle.scrollLeft = this._60_it;
            this._60_it += (this._60_is_next ? next_frame : -next_frame);
            this.#requestUpdate();//loop
        } else
            carrossel_goto_image(this._60_pagina_inicial);
    }

    static init() {
        this.#requestUpdate();
    }
}



function ShowPopUpImgCarrosselV2({ img_src, closePopup, id_img_open, titulo_pop_up = '', injetarHtml = null, on_change_page = null, on_open_page = null, on_close_page = null }) {

    function ViewDots({ img_src, pagina_inicial }) {

        const indents = [];
        for (let i = 0; i < img_src.length; i++) {
            indents.push(i == pagina_inicial ? <span id="pop_up_touch_dot_selecionado" name={i} onClick={() => {
                carrossel_goto_image(i);
            }} key={'ViewDots' + i}></span> : <span name={i} onClick={() => {
                carrossel_goto_image(i);
            }
            } key={'ViewDots' + i}></span>);
        }
        return indents;
    }
    function ViewIMG({ img_src }) {
        const indents = [];
        for (let i = 0; i < img_src.length; i++) {
            indents.push(<article className="pop_up_mobileCircle" key={'ViewIMG' + i}>
                <a>
                    <img src={img_src[i]} className="pop_up_imagem_carrossel" />
                </a>
            </article>);
        }
        return indents;
    }

    const overflow_qtd_img = img_src !== null && img_src.length > 100;

    const GLOBAL_TITULO_CARROSSEL = titulo_pop_up;
    const pagina_inicial = GLOGAL_ID_CARROSSEL;
    const [state, setState] = useState(false);

    const ref_js_pop_up_confirmacao = useRef();
    const ref_pop_up_container_mobileCircle = useRef();
    const ref_pop_up_console = useRef();
    useEffect(() => {
        if (!state) {
            setState(true);
            _60_FPS_LOOP._60_on_change_page = null;
        } else {

            setIdPopUpCarrossel(id_img_open);
            if (!overflow_qtd_img) {
                const js_pop_up_confirmacao = ref_js_pop_up_confirmacao.current;
                const pop_up_container_mobileCircle = ref_pop_up_container_mobileCircle.current;
                const pop_up_console = ref_pop_up_console.current;
                if (js_pop_up_confirmacao !== null && pop_up_container_mobileCircle !== null && pop_up_console !== null) {
                    if (on_open_page !== null) {
                        on_open_page();
                    }
                    carrossel_goto_image(id_img_open);//faz o jump para a imagem que o usuario clicou
                    //DEPOIS DE CARREGAR A IMAGEM -> MUDE A PAGINA PARA A PAGINA SOLICITADA
                    const _redundancia_ativador_pagina = new Image();
                    _redundancia_ativador_pagina.src = img_src[pagina_inicial];

                    _redundancia_ativador_pagina.onload = function () {
                        _60_FPS_LOOP._60_on_change_page = on_change_page;
                        //carrossel_goto_image(pagina_inicial);//faz o jump para a imagem que o usuario clicou
                    };
                    ///

                    let touchstartX, touchX;
                    let zoom_p1, zoom_p2, wait_zoom = false;
                    pop_up_container_mobileCircle.addEventListener('touchstart', e => {
                        pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].classList.remove("pop_up_transitions_by_transitions");
                        pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].classList.remove("pop_up_transitions_by_transitions_lite");
                        if (wait_zoom)
                            return;
                        if (e.touches.length == 1) {
                            zoom_p1 = zoom_p2 = null;
                            touchstartX = e.touches[0].clientX;
                        } else {
                            pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].classList.add("pop_up_transitions_by_transitions_lite");
                            wait_zoom = true;
                            zoom_p1 = e.touches[0];
                            zoom_p2 = e.touches[1];
                            pop_up_container_mobileCircle.style.overflowX = 'hidden';
                            pop_up_console.innerText = 'Modo ZOOM ativado';
                        }
                    });
                    pop_up_container_mobileCircle.addEventListener('touchmove', e => {
                        e.preventDefault();
                        if (e.touches.length == 1)
                            touchX = e.touches[0].clientX;
                        else {
                            let escala = Math.sqrt(Math.pow((e.touches[0].clientX - e.touches[1].clientX), 2) + Math.pow((e.touches[0].clientY - e.touches[1].clientY), 2)) / 90.0;
                            const escala_iniciar_zoom = Math.sqrt(Math.pow((zoom_p1.clientX - zoom_p2.clientX), 2) + Math.pow((zoom_p1.clientY - zoom_p2.clientY), 2)) / 180.0;
                            escala -= escala_iniciar_zoom;
                            const touchDiffX = ((e.touches[0].clientX - zoom_p1.clientX) + e.touches[1].clientX - zoom_p2.clientX) / 2.0;
                            const touchDiffY = ((e.touches[0].clientY - zoom_p1.clientY) + e.touches[1].clientY - zoom_p2.clientY) / 2.0;
                            const transform = (!(escala < 1 || escala < escala_iniciar_zoom)) ? 'scale(' + escala + ',' + escala + ') translate(' + touchDiffX + 'px, ' + touchDiffY + 'px)' : 'translate(' + touchDiffX + 'px, ' + touchDiffY + 'px)';
                            pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].style.transform = transform;
                        }

                    });

                    pop_up_container_mobileCircle.addEventListener('touchend', e => {
                        if (zoom_p1 == null && zoom_p2 == null) {
                            const pop_up_touch_dot_selecionado = document.getElementById("pop_up_touch_dot_selecionado");
                            if (pop_up_touch_dot_selecionado !== null) {

                                const paginaAnterior = getIdPopUpCarrossel();
                                setIdPopUpCarrossel(getIdPopUpCarrossel() + ((touchX - touchstartX) <= 0 ? 1 : -1), pop_up_touch_dot_selecionado.parentElement.children.length)
                                //const pop_up_container_mobileCircle = document.getElementById("pop_up_container_mobileCircle");
                                const max = (getIdPopUpCarrossel() * (pop_up_container_mobileCircle.clientWidth + 6));
                                const pos_atual = pop_up_container_mobileCircle.scrollLeft;
                                //iniciando o loop passador
                                _60_FPS_LOOP._60_is_next = max > pos_atual;
                                _60_FPS_LOOP._60_pop_up_container_mobileCircle = pop_up_container_mobileCircle;
                                _60_FPS_LOOP._60_it = pos_atual;
                                _60_FPS_LOOP._60_max = max;
                                _60_FPS_LOOP._60_pagina_anterior = paginaAnterior;
                                _60_FPS_LOOP._60_pagina_inicial = getIdPopUpCarrossel();
                                _60_FPS_LOOP._60_on_change_page = on_change_page;
                                _60_FPS_LOOP.init();
                                //fim loop passador
                            }
                        } else {
                            setTimeout(() => {
                                pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].classList.add("pop_up_transitions_by_transitions");
                                pop_up_container_mobileCircle.style.overflowX = 'auto';
                                pop_up_container_mobileCircle.children[getIdPopUpCarrossel()].children[0].children[0].style.transform = 'scale(1,1) translate(0px, 0px)';
                                wait_zoom = false;
                                pop_up_console.innerText = GLOBAL_TITULO_CARROSSEL;
                            }, 200);
                        }
                    });

                    js_pop_up_confirmacao.addEventListener('click', e => {//pra quando clicar fora na parte preta do aviso, pra ele fechar tambem
                        if (e.target === js_pop_up_confirmacao)
                            fecharPopUp();
                    });
                    document.querySelectorAll("html")[0].style.overflow = "hidden";
                }
            } else {
                const erro = 'ERRO POPUP CARROSSEL: Imagem não é uma lista de base64';
                console.log(erro);
                throw erro;
            }
        }
    }, [state]);


    function fecharPopUp(delay = 50) {
        controladorTelaDinamicaPopUp(true);
        setTimeout(() => {
            if (on_close_page !== null)
                on_close_page();
            document.querySelectorAll("html")[0].style.overflow = "auto";
            closePopup();
        }, delay);
    }

    const [stylePrevent_js_pop_up_observador_topo, setstylePrevent_js_pop_up_observador_topo] = useState(null);
    const [stylePrevent_js_pop_up_confirmacao, setstylePrevent_js_pop_up_confirmacao] = useState(null);
    const [stylePrevent_js_pop_up_header, setstylePrevent_js_pop_up_header] = useState(null);
    const [stylePrevent_INFO_JS_ID_GLOBAL_POP_UP, setstylePrevent_INFO_JS_ID_GLOBAL_POP_UP] = useState(null);


    function controladorTelaDinamicaPopUp(force_close = false) {
        const js_pop_up_observador_topo = document.getElementById('js_pop_up_observador_topo');
        const js_pop_up_confirmacao = document.getElementById('js_pop_up_confirmacao');
        const js_pop_up_header = document.getElementById('js_pop_up_header');
        const INFO_JS_ID_GLOBAL_POP_UP = document.getElementById('INFO_JS_ID_GLOBAL_POP_UP');
        if (js_pop_up_observador_topo !== null && js_pop_up_confirmacao !== null && js_pop_up_header !== null && INFO_JS_ID_GLOBAL_POP_UP !== null) {
            const dsitanciaTop = js_pop_up_observador_topo.getBoundingClientRect().top;

            js_pop_up_header.style.transition = 'none';
            if ((dsitanciaTop < 0 || document.activeElement.tagName === 'TEXTAREA') && !force_close) {

                setstylePrevent_js_pop_up_observador_topo(js_pop_up_observador_topo.style);
                setstylePrevent_js_pop_up_confirmacao(js_pop_up_confirmacao.style);
                setstylePrevent_js_pop_up_header(js_pop_up_header.style);
                setstylePrevent_INFO_JS_ID_GLOBAL_POP_UP(INFO_JS_ID_GLOBAL_POP_UP.style);
                document.querySelectorAll("html")[0].style.overflow = "auto";

                js_pop_up_confirmacao.style.backgroundColor = 'white';
                const prev_top = js_pop_up_observador_topo.getBoundingClientRect().top;
                for (let i = prev_top; i > 0; i--) {
                    setTimeout(() => {
                        js_pop_up_observador_topo.style.top = i + 'px'
                    }, (prev_top - i) * 1);
                }
                js_pop_up_observador_topo.style.top = '0px';

                js_pop_up_confirmacao.style.position = 'static';
                js_pop_up_observador_topo.style.position = 'absolute';
                js_pop_up_observador_topo.style.animation = 'none';

                js_pop_up_observador_topo.style.left = '1.8%';

                js_pop_up_header.style.position = 'fixed';
                js_pop_up_header.style.width = '100%';
                js_pop_up_header.style.height = '38px';
                js_pop_up_header.style.backgroundColor = 'white';
                js_pop_up_header.style.top = '0px';
                js_pop_up_header.style.right = '0px';
                INFO_JS_ID_GLOBAL_POP_UP.style.marginTop = '13px';
            } else {
                if (stylePrevent_js_pop_up_observador_topo !== null) {
                    js_pop_up_observador_topo.style = stylePrevent_js_pop_up_observador_topo;
                    js_pop_up_observador_topo.style.animation = '.20s linear forwards pop_up_zoom_animation_no_animation';
                }
                if (stylePrevent_js_pop_up_confirmacao !== null) {
                    js_pop_up_confirmacao.style = stylePrevent_js_pop_up_confirmacao;

                }
                if (stylePrevent_js_pop_up_header !== null) {
                    js_pop_up_header.style = stylePrevent_js_pop_up_header;
                }
                if (stylePrevent_INFO_JS_ID_GLOBAL_POP_UP !== null) {
                    INFO_JS_ID_GLOBAL_POP_UP.style = stylePrevent_INFO_JS_ID_GLOBAL_POP_UP;
                }
            }
        }

    }
    return (
        <>
            {!overflow_qtd_img && state ?
                (<>
                    <article style={{ display: 'none' }} name="call->nativeAplicationOnBackPress" onClick={fecharPopUp}></article>
                    <div className='pop_up_confirmacao' id='js_pop_up_confirmacao' onClick={
                        () => {
                            setTimeout(() => {
                                controladorTelaDinamicaPopUp();
                            }, 1);
                        }
                    } ref={ref_js_pop_up_confirmacao}>
                        <div className="pop_up p_img" id="js_pop_up_observador_topo">
                            <div className="container" id="INFO_JS_ID_GLOBAL_POP_UP">
                                <div className="pop_up_header" id='js_pop_up_header' style={{ marginTop: "-5px", marginBottom: "5px" }}>
                                    <h2 style={{ color: "rgb(48, 116, 218)" }} ref={ref_pop_up_console}>{titulo_pop_up}</h2><button id='js_pop_up_confirmacao_close_btn' onClick={() => {
                                        // ref_js_pop_up_confirmacao.current.click();
                                        fecharPopUp()
                                    }}>X</button>
                                </div>
                                <section className="pop_up_touch" >
                                    <div className="pop_up_container_mobileCircle" id="pop_up_container_mobileCircle" ref={ref_pop_up_container_mobileCircle}>
                                        <ViewIMG img_src={img_src} />
                                    </div>
                                    <div className="pop_up_touch_dot">
                                        <ViewDots img_src={img_src} pagina_inicial={pagina_inicial} />
                                    </div>
                                </section>
                                {injetarHtml}
                            </div>
                            <div className="pop_up_msg_opc">
                                {/* <button onClick={fecharPopUp}>fechar</button> */}
                            </div>
                        </div>
                    </div>
                </>)
                : null
            }
        </>
    )
}
/*
ShowPasswordView := responsável por receber uma entrada de senha e quando clica em ok faz o call_back
*/
function ShowPasswordView(ShowAlertView, f_call_back_on_press_ok, setStateLoader) {
    ShowAlertView('', () => {
        if (f_call_back_on_press_ok !== null) {
            const IDX_PASSWORD_INPUT_POP_UP = document.getElementById('IDX_PASSWORD_INPUT_POP_UP');
            if (IDX_PASSWORD_INPUT_POP_UP !== null) {
                f_call_back_on_press_ok(IDX_PASSWORD_INPUT_POP_UP.value);
            }
        }
    });
    const titulo_container = 'Autenticação';
    const titulo_btn_nao__ = 'Cancelar';
    const titulo_btn_sim__ = 'Prosseguir';
    const container_height = '200px';
    setTimeout(() => {
        const IDX_9989_POP_UP_MSG = document.getElementById('IDX_9989_POP_UP_MSG');
        const INFO_JS_ID_GLOBAL_POP_UP = document.getElementById('INFO_JS_ID_GLOBAL_POP_UP');
        const IDX_JS_POP_UP_TITULO_H2 = document.getElementById('IDX_JS_POP_UP_TITULO_H2');
        const pop_up_idx_btn_sim = document.getElementById('pop_up_idx_btn_sim');
        const pop_up_idx_btn_nao = document.getElementById('pop_up_idx_btn_nao');
        if (IDX_9989_POP_UP_MSG !== null && INFO_JS_ID_GLOBAL_POP_UP !== null && IDX_JS_POP_UP_TITULO_H2 !== null && pop_up_idx_btn_sim !== null && pop_up_idx_btn_nao !== null) {
            pop_up_idx_btn_nao.innerText = titulo_btn_nao__;
            pop_up_idx_btn_sim.innerText = titulo_btn_sim__;
            pop_up_idx_btn_sim.parentElement.style.gap = '20px';
            pop_up_idx_btn_sim.parentElement.style.paddingTop = '10px';
            pop_up_idx_btn_sim.parentElement.style.paddingBottom = '5px';
            INFO_JS_ID_GLOBAL_POP_UP.parentElement.style.height = container_height;
            INFO_JS_ID_GLOBAL_POP_UP.parentElement.style.padding = '5px 0px';
            IDX_JS_POP_UP_TITULO_H2.innerText = titulo_container;
            const _inject_html = ReactDOM.createRoot(IDX_9989_POP_UP_MSG);
            _inject_html.render(
                <div className='container_style_custom_view_pop_up_password'>
                    <p>Necessário sua senha para esta ação!</p>
                    <input id='IDX_PASSWORD_INPUT_POP_UP' type='password' placeholder='Sua senha...' />
                    <article>
                        <label><input type='checkbox' onClick={(e) => {
                            const IDX_PASSWORD_INPUT_POP_UP = document.getElementById('IDX_PASSWORD_INPUT_POP_UP');
                            if (IDX_PASSWORD_INPUT_POP_UP !== null) {
                                const campo_tipo = e.target.checked ? 'text' : 'password';
                                IDX_PASSWORD_INPUT_POP_UP.type = campo_tipo;
                            }
                        }} />Mostrar senha</label>
                        <p className='x889_nao_sei_a_senha' onClick={(e) => {
                            e.target.style.display = 'none';
                            if (setStateLoader !== null) { setStateLoader(true) }
                        }}>Não sei minha senha</p>
                    </article>
                </div>
            );
        }
    }, 1);
}

export { ShowPopUpConfirmationV2, ShowPopUpImgCarrosselV2, ShowPopUpOkOrNoV2, ShowPasswordView };